import { z } from "zod";
import { xAxisDefinitions, yAxisDefinitions } from "./definitions";
// Zod schema
export const DatePresetSchema = z.enum([
    "last_24_hours",
    "today",
    "yesterday",
    "last_7_days",
    "last_30_days",
    "last_90_days",
    "last_180_days",
    "last_365_days",
    "year_to_date",
    "custom"
]);
export const DateRangeSchema = z.object({
    from: z.string(),
    to: z.string()
});
export const DateFilterSchema = z.object({
    dimension: z.enum([
        "purchaseDate",
        "installDate",
        "firstPurchaseDate",
        "tsDate",
        "mrrDate"
    ]),
    range: DateRangeSchema.optional(),
    preset: DatePresetSchema.optional()
});
export const ProductDurationSchema = z.object({
    productId: z.string(),
    duration: z.string()
});
export const CampaignIdInfo = z.object({
    campaignId: z.string(),
    experimentId: z.string()
});
export const UserPropertyInfo = z.object({
    key: z.string(),
    valueType: z.enum([
        "string",
        "number"
    ])
});
export const ChartDataParamSchema = z.object({
    breakdown: z.string().optional(),
    defaultBreakdown: z.string().optional(),
    xAxis: z.enum([
        ...xAxisDefinitions.map((e)=>e.key)
    ]),
    yAxis: z.enum([
        ...yAxisDefinitions.map((e)=>e.key)
    ]),
    include: z.array(z.enum([
        ...yAxisDefinitions.map((e)=>e.key)
    ])).optional(),
    dateInterval: z.string().optional(),
    conversionTimeframe: z.string().optional(),
    dateFilter: DateFilterSchema.optional(),
    organizationId: z.array(z.number()),
    applicationId: z.array(z.number()).optional(),
    integration: z.array(z.string()).optional(),
    eventType: z.array(z.string()).optional(),
    subStartType: z.array(z.string()).optional(),
    revenueType: z.array(z.string()).optional(),
    paywallId: z.array(z.string()).optional(),
    variantId: z.array(z.number()).optional(),
    experimentId: z.array(z.number()).optional(),
    campaignId: z.array(z.string()).optional(),
    productDurationInfo: z.array(ProductDurationSchema).optional(),
    campaignIdInfo: z.array(CampaignIdInfo).optional(),
    userPropertyInfo: z.array(UserPropertyInfo).optional(),
    productDuration: z.array(z.string()).optional(),
    countryCode: z.array(z.string()).optional(),
    productId: z.array(z.string()).optional(),
    placement: z.array(z.string()).optional(),
    environment: z.array(z.string()).optional(),
    store: z.array(z.string()).optional(),
    appVersion: z.array(z.string()).optional(),
    sdkVersion: z.array(z.string()).optional(),
    autoRenewStatus: z.array(z.string()).optional(),
    revenueSource: z.array(z.string()).optional(),
    totals: z.boolean().optional()
});
